import { orderXClient } from '@/service/client'
import { unwrapServerMessage } from '@/service/server-message'
import {
  CancelOrderParams,
  NewOrderParams,
  OrderExecutionCommand,
  OrderExecutionCommandList,
  UpdateOrderParams,
} from '@/types/generated/execution'
import { ServerMessage } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function executeOrder(payload: OrderExecutionCommand) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      executionBatch: {
        executionCommands: { commands: [payload] },
      },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function createOrder(payload: NewOrderParams) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      executionBatch: {
        executionCommands: {
          commands: [
            {
              accountId: payload.accountId,
              new: payload,
            },
          ],
        },
      },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function updateOrder(payload: UpdateOrderParams) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      executionBatch: {
        executionCommands: {
          commands: [
            {
              accountId: payload.accountId,
              update: payload,
            },
          ],
        },
      },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function cancelOrder(payload: CancelOrderParams) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      executionBatch: {
        executionCommands: {
          commands: [
            {
              accountId: payload.accountId,
              cancel: payload,
            },
          ],
        },
      },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

/**
 * Execute multiple orders in a single batch request
 */
export async function executeOrderBatch(payload: OrderExecutionCommandList) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      executionBatch: {
        executionCommands: payload,
      },
    })
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

/**
 * Create multiple orders in a single batch request
 */
export async function createOrderBatch(orders: NewOrderParams[]) {
  const commands: OrderExecutionCommand[] = orders.map((order) => ({
    accountId: order.accountId,
    new: order,
  }))

  return executeOrderBatch({ commands })
}
